import React, { Component } from 'react';
import CampaignForm from './CampaignForm';

class CampaignCreatePageView extends Component {
  render() {
    return (
      <div>
        <nav className="navbar navbar-expand navbar-light bg-light">
          <div className="navbar-brand">Campagne toevoegen</div>
        </nav>
        <div className="container-fluid my-4">
          <div className="row">
            <div className="col-md-6 offset-md-3 col-lg-4 offset-lg-4">
              <div className="card">
                <div className="card-body">
                  <CampaignForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CampaignCreatePageView;
